import { gsap, TimelineMax } from 'gsap/all'

export const initMetrics = () => {
  const popupSection = document.querySelector('.hidden-metric-popups')

  if (!popupSection) {
    return
  }

  const buttons = [...document.querySelectorAll('.js_open_metrics_popup')]
  new Modal(popupSection, buttons)
}

class Modal {
  constructor (element, triggers) {
    this.element = element
    this.triggers = triggers
    this.closeButton = this.element.querySelector('.js_close_metrics_popup')
    this.layer = document.querySelector('main .js-layer')
    this.active = 0
    this.isOpen = false
    this.init()
  }

  open = () => {
    document.body.style.overflow = 'hidden'
    this.element.querySelector(`.metric_popup_${this.active}`).style.display = 'block'
    this.isOpen = true

    this.tweenLayer('in')
    this.tweenElement('in')
    this.tweenElements('in')
  }

  tweenElement (mode) {
    gsap.to(this.element, 0.5, {
      ease: 'expo.out',
      x: mode === 'in' ? 0 : '50%',
      opacity: mode === 'in' ? 1 : 0,
      onStart: () => {
        this.element.style.pointerEvents = 'all'
        this.element.style.willChange = 'transform'
      },
      onComplete: () => {
        this.element.style.willChange = 'unset'

        if (mode === 'out') {
          this.element.querySelector(`.metric_popup_${this.active}`).style.display = 'none'
          this.isOpen = false
          this.active = false
          this.element.style.pointerEvents = 'none'
        }
      }
    })
  }

  tweenElements (mode) {
    const elements = [this.element.querySelector(`.metric_popup_${this.active}`).querySelectorAll('.child')]

    if (mode === 'in') {
      gsap.to(elements, 0.5, {
        x: '0%',
        stagger: 0.05,
        ease: 'expo.out',
        onStart: () => {
          gsap.set(elements, { willChange: 'transform' })
        },
        onComplete: () => {
          gsap.set(elements, { willChange: 'unset' })
        }
      })

      gsap.to(elements, 0.3, {
        opacity: 1,
        delay: 0.1,
        stagger: 0.05,
        ease: 'power2.out'
      })
    } else {
      gsap.set(elements, {
        opacity: 0,
        delay: 0.5,
        x: '100%'
      })
    }
  }

  close = () => {
    if (!this.isOpen) { return false }
    document.body.removeAttribute('style')

    this.tweenLayer('out')
    this.tweenElement('out')
    this.tweenElements('out')
  }

  tweenLayer(mode) {
    gsap.to(this.layer, 0.5, {
      opacity: mode === 'in' ? 0.5 : 0,
      ease: 'power4.out',
      onComplete: () => {
        this.layer.style.pointerEvents = mode === 'in' ? 'all' : 'none'
      }
    })
  }

  bindTriggers () {
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        this.active = index
        this.open()
      })
      new TriggerHover(trigger)
    })

    this.closeButton.addEventListener('click', this.close)
    this.layer.addEventListener('click', this.close)

    window.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        this.close()
      }
    })
  }

  init () {
    this.bindTriggers()
  }
}

class TriggerHover {
  constructor(element) {
    this.trigger = element
    this.icon = this.trigger.querySelectorAll('.js-icon')
    this.text = this.trigger.querySelectorAll('.js-text')
    this.bgColor = this.trigger.querySelector('.js-icon').dataset.hover

    this.offset = 6
    this.mouseover = false

    this.init()
  }

  init = () => {
    this.setDefaults()
    this.createTimelines()
    this.bindEvents()
  }

  setDefaults = () => {
    gsap.set(this.text, { y: this.offset, opacity: 0 })
  }

  createTimelines = () => {
    this.createTimelineEnter()
    this.createTimelineLeave()
  }

  createTimelineEnter = () => {
    this.timelineEnter = new TimelineMax({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false
        if (!this.mouseover) {
          this.timelineLeave.restart()
        }
      }
    })

    this.timelineEnter
      .to(this.icon, 0.25, { backgroundColor: this.bgColor, ease: 'power2.inOut' }, 'a')
      .to(this.icon, 0.25, { rotation: -90, ease: 'power2.inOut' }, 'a')
  }

  createTimelineLeave = () => {
    this.timelineLeave = new TimelineMax({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false
        if (this.mouseover) {
          this.timelineEnter.restart()
        }
      }
    })

    this.timelineLeave
      .to(this.icon, 0.25, { backgroundColor: '#06221a', ease: 'power2.inOut' }, 'a')
      .to(this.icon, 0.25, { rotation: -180, ease: 'power2.inOut' }, 'a')
  }

  bindEvents = () => {
    this.trigger.addEventListener('mouseenter', this.handleEnter)
    this.trigger.addEventListener('mouseleave', this.handleLeave)
  }

  handleEnter = () => {
    this.mouseover = true
    if (!this.timelinePlaying) {
      this.timelineEnter.restart()
    }
  }

  handleLeave = () => {
    this.mouseover = false
    if (!this.timelinePlaying) {
      this.timelineLeave.restart()
    }
  }
}
